/**
 * Configuración de la landing Navimarket 2026.
 *
 * Lo que cambia según dónde esté desplegada la landing (endpoint de la API,
 * contenedor de analítica, URL pública) viaja por variables de entorno, con el
 * valor de hoy como respaldo para que un clon del repo arranque sin configurar
 * nada. La tabla completa está en README.md.
 *
 * Lo que NO es entorno sino contenido —fechas, textos, enlaces del cliente—
 * vive aquí escrito, porque cambiarlo es una decisión editorial y merece
 * quedar en el historial del repo, no en la configuración del despliegue.
 */

/** Ambiente **dev** de Nubity/Evertec (ver navimarket-api-dev-guide_v1.md).
 *  Producción (pendiente): https://portal.athmovil.com/navimarket/api/application */
const DEFAULT_API_URL = 'https://70vy7qr3jl.execute-api.us-east-1.amazonaws.com/dev/api/application';

/** Un VITE_API_MODE mal escrito no debe convertir la producción en un simulacro. */
function resolveApiMode(raw: string | undefined): 'mock' | 'live' {
  const mode = raw?.trim().toLowerCase();
  if (!mode) return 'live';
  if (mode === 'mock' || mode === 'live') return mode;
  console.warn(`[navimarket] VITE_API_MODE="${raw}" no es "mock" ni "live"; usando "live".`);
  return 'live';
}

export const config = {
  /** "mock" simula el envío (latencia + éxito). "live" hace POST a API_URL. */
  API_MODE: resolveApiMode(import.meta.env.VITE_API_MODE),

  /**
   * POST /api/application.
   * Ojo: todo envío en modo "live" cae en el Google Sheet de revisión del
   * cliente. Para probar el formulario sin ensuciarlo, VITE_API_MODE=mock.
   */
  API_URL: import.meta.env.VITE_API_URL?.trim() || DEFAULT_API_URL,

  /**
   * Cierre de la convocatoria: al terminar el 29 de septiembre, hora de Puerto
   * Rico (AST, UTC−4 todo el año — PR no cambia de hora). Pasada esta fecha el
   * formulario se reemplaza solo por el mensaje de cierre, sin desplegar nada.
   */
  REGISTRATION_DEADLINE: '2026-09-29T23:59:59-04:00',

  /**
   * Interruptor de emergencia: en `false` la convocatoria cierra ya mismo, sin
   * importar la fecha. En `true` manda REGISTRATION_DEADLINE.
   * Para probar el cierre antes de tiempo no hace falta tocar esto — ver los
   * parámetros de URL documentados en src/lib/registration-window.ts.
   */
  REGISTRATION_OPEN: true,

  /** Mensaje configurable que se muestra cuando la convocatoria cierra. */
  CLOSED_MESSAGE:
    'Recibimos solicitudes para Navimarket 2026 hasta el 29 de septiembre. Gracias a todos los negocios que aplicaron, el equipo está revisando todas las solicitudes y contactará por correo a los seleccionados.',

  /** Datos del evento, confirmados por el cliente. */
  EVENT: {
    date: 'Domingo, 15 de noviembre de 2026',
    dateShort: 'DOM · 15 · NOV · 2026',
    weekday: 'Domingo',
    schedule: '10:00 a.m. – 6:00 p.m.',
    venue: 'Centro de Convenciones',
    city: 'San Juan, PR',
    admission: 'Gratis',
  },
} as const;
